import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Button } from '@dds-uicore/all';
import { map } from 'rxjs/operators';
import { DataService } from '../data.service';
import { ItemInfoModel } from '../model/item-info-model';
import { URLParams } from '../model/urlparams';
import { AgileSDKService } from '../services/agile-sdk.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  @ViewChild("modalPartTrigger", { static: false }) modalPartTrigger:ElementRef;
  partNumber : string = ''
  partClass : string = ''
  partType : string = ''
  partLP : string =''
  partRevision : string = ''
  toggleValue = true
  urlParams:URLParams;
  partAttributes:ItemInfoModel = new ItemInfoModel();
  ItemInfoView = [
    {"itemAttr" : "Number",
     "itemVal" : ""
    },{
      "itemAttr" : "Part Class",
      "itemVal" : ""
    },{
      "itemAttr" : "Part Type",
      "itemVal" : ""
    },{
      "itemAttr" : "Revision",
      "itemVal" : ""
    },{
      "itemAttr" : "Proj-Platform Affected",
      "itemVal" : ""
    },{
      "itemAttr" : "E-Promoted Platforms",
      "itemVal" : ""
    },{
      "itemAttr" : "Operating System (OS)",
      "itemVal" : ""
    },{
      "itemAttr" : "Language",
      "itemVal" : ""
    },{
      "itemAttr" : "Royalty Flag",
      "itemVal" : ""
    },{
      "itemAttr" : "Regions Affected",
      "itemVal" : ""
    },{
      "itemAttr" : "LOBs Affected",
      "itemVal" : ""
    }
  ]
  constructor(private dataService:DataService,private aglService:AgileSDKService) { 
    //  this.partNumber = "005CT";
    // this.partNumber = '005CT';
    // this.partRevision = 'X09-00';
    this.urlParams = this.dataService.getUrlParams();
    
    console.log('URL Params ',this.urlParams)
    if(this.urlParams != undefined)
    {
      console.log('setting the Part Number to ',this.urlParams.partNumber)
      this.partNumber = this.urlParams.partNumber;
      this.partRevision = this.urlParams.partRevision;
      this.getPartDetails(this.partNumber);
    }
  }

  ngOnInit(): void {
    const toggleBtn = document.querySelectorAll("[data-toggle=\"dds__button\"]");
    new Button(toggleBtn[0]);
   
  }
  openPartDetails(){
    let partModalTrigger = document.getElementById("modalPartTrigger");
    partModalTrigger.click();
    this.getPartDetails(this.partNumber);
   }

   getPartDetails(partNumber:string){
     console.log('Getting Part Details')
     this.aglService.getPartAttributeInfo(partNumber).subscribe((itemInfo) => {
       console.log('Part Attrs ',itemInfo)
       this.partAttributes = itemInfo;
     });
   }
}
